import { Button, Divider, Stack } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router';
import { useAppSelector } from '../../hooks';
import ErrorList from '../ErrorList';

const LINKS = [
  { to: '/admin/users', label: 'Użytkownicy' },
  { to: '/admin/points/add', label: 'Dodaj punkty' },
  { to: '/admin/match-days', label: 'Dni meczowe' },
  { to: '/admin/email', label: 'Wyślij maila' }
];

export default function AdminArea() {
  const message = useAppSelector((s) => s.admin.message);
  const { pathname } = useLocation();

  return (
    <div className="admin-area">
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 1.5 }}>
        <Button component={Link} to="/" size="small">Wyniki</Button>
        {LINKS.map((link) => (
          <Button
            key={link.to}
            component={Link}
            to={link.to}
            size="small"
            variant={pathname.startsWith(link.to) ? 'contained' : 'text'}
          >{link.label}</Button>
        ))}
      </Stack>
      <Divider sx={{ mb: 2 }} />
      {message.messages && (
        <ErrorList errorMessages={message.messages} messageType={message.type} />
      )}
      <Outlet />
    </div>
  );
}
